// src/ecrans/useEstEtroit.js — « on est au téléphone » pour les écrans NEST :
// la largeur de la maquette téléphone (640 px et moins), suivie en direct.

import { useEffect, useState } from "react";

const Q = "(max-width: 640px)";

export default function useEstEtroit() {
  const lire = () => typeof window !== "undefined" && Boolean(window.matchMedia) && window.matchMedia(Q).matches;
  const [e, setE] = useState(lire);
  useEffect(() => {
    if (!window.matchMedia) return undefined;
    const m = window.matchMedia(Q);
    const f = () => setE(m.matches);
    if (m.addEventListener) m.addEventListener("change", f);
    return () => m.removeEventListener && m.removeEventListener("change", f);
  }, []);
  return e;
}
